import React, { useEffect, useState } from 'react';

// Reading pane. If the message is a KryptaMail PQC envelope, it is decrypted via
// the crypto-service and the signature-verification badge is shown. Otherwise
// the plaintext/HTML body renders normally.
export function MessageView({ email, session }) {
  const { jmap, crypto } = session;
  const [full, setFull] = useState(null);
  const [decrypted, setDecrypted] = useState(null);
  const [sig, setSig] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setFull(null); setDecrypted(null); setSig(null); setErr(null);
    (async () => {
      try {
        const msg = await jmap.getEmailBody(email.id);
        setFull(msg);
        const raw = extractText(msg);
        const envelope = tryParsePqc(raw);
        if (envelope) {
          // The recipient's KEM private key would come from the browser keystore.
          // When unlocked, call crypto.open(). Here we surface the state.
          const sender = envelope.from;
          const senderPub = await crypto.lookupRecipient(sender);
          setSig({ pending: true, sender, hasSenderKey: !!senderPub });
          // const out = await crypto.open({ envelope, recipientKemPrivateKey, senderSigPublicKey: senderPub.sigPublicKey });
          // setDecrypted(out.plaintext); setSig(out.signature);
        }
      } catch (e) { setErr(e.message); }
    })();
  }, [email.id, jmap, crypto]);

  return (
    <article className="km-message">
      <header className="km-message-head">
        <h2 className="km-message-subject">{email.subject || '(no subject)'}</h2>
        <div className="km-message-meta km-dim">
          <span>{fromLabel(email.from)}</span>
          <span className="km-faint">{fmtDate(email.receivedAt)}</span>
        </div>
        {sig && (
          <div className={`km-pqc-chip ${sig.valid ? 'verified' : sig.pending ? '' : 'invalid'}`}
            style={{ marginTop: 10 }}>
            {sig.pending
              ? '🔐 Post-quantum encrypted · unlock your key to read'
              : sig.valid
                ? '🔐 Post-quantum encrypted · signature verified'
                : '⚠️ Signature INVALID'}
          </div>
        )}
      </header>

      <div className="km-message-body">
        {err && <div className="km-login-error">⚠️ {err}</div>}
        {decrypted != null
          ? <pre className="km-message-plain">{decrypted}</pre>
          : full
            ? <pre className="km-message-plain">{extractText(full) || email.preview}</pre>
            : <div className="km-faint">Loading…</div>}
      </div>
    </article>
  );
}

function extractText(msg) {
  if (!msg?.bodyValues) return '';
  const part = (msg.textBody && msg.textBody[0]) || (msg.htmlBody && msg.htmlBody[0]);
  const v = part && msg.bodyValues[part.partId];
  return v?.value || '';
}
function tryParsePqc(raw) {
  // Our PQC MIME part carries application/kryptamail-pqc+json; if the body is the
  // raw envelope JSON, parse it.
  try {
    const obj = JSON.parse(raw);
    if (obj && obj.suite && obj.kem && obj.body) return obj;
  } catch { /* not a PQC envelope */ }
  return null;
}
function fromLabel(from) {
  if (!from?.length) return '(unknown)';
  const f = from[0];
  return f.name ? `${f.name} <${f.email}>` : f.email;
}
function fmtDate(iso) {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}
